import { LogInPaths } from '@bbkAdminComponents/log-in-flow/log-in-paths';

/**
 * Resolves a redirect target to a same-origin relative path. Anything that
 * points off-origin (or cannot be parsed) collapses to the fallback so a
 * query-param-supplied `redirectUri` cannot be used for an open redirect.
 * Mirrors the same-origin validation used in `cbidp-exchange`.
 */
export const toSafeInternalRedirect = (
  target: string | undefined | null,
  fallback: string = LogInPaths.company
): string => {
  if (!target) {
    return fallback;
  }
  try {
    const url = new URL(target, window.location.origin);
    if (url.origin !== window.location.origin) {
      return fallback;
    }
    const relativePath = url.pathname + url.search + url.hash;
    // A "//host" (or "/\\host") path passes the origin check above but
    // window.location.assign would treat it as protocol-relative / off-origin.
    if (/^\/[/\\]/.test(relativePath)) {
      return fallback;
    }
    return relativePath;
  } catch {
    return fallback;
  }
};
